import { isDefinedString } from "et3-type-guards";

import { TTableHeader } from "../../Types";
import SectionHeader from "../et3-section/SectionHeader";
import { withLiteObserverAndTheme } from "../et3-enhanced-render";

const TableTitle = withLiteObserverAndTheme<TTableHeader>((props) => {
  const { width, title, isCollapsible, sectionId, defaultOpen, rowsCount } =
    props;

  return isDefinedString(title) ? (
    <SectionHeader
      title={title}
      summary={""}
      count={isCollapsible ? rowsCount : 0}
      sectionId={sectionId}
      defaultOpen={defaultOpen}
      isCollapsible={isCollapsible}
      width={width}
    />
  ) : null;
});
export default TableTitle;
